import AppTitle from '../support/AppTitle.js';
import useAuth from "../auth/useAuth.js";
import useSettings from "../settings/useSettings.js";
import TagPicker from '../tags/TagPicker.js';
import TagService from '../tags/TagService.js';
import PageService from '../pages/PageService.js';
import Page from '../pages/Page.js';
import PagePreview from '../pages/PagePreview.js';
import SearchBar from '../support/SearchBar.js';
import { HexPagePreviewGrid } from './PagePreviewHex.js';
import { RenaiEventPagePreviewGrid } from './PagePreviewRenaiEvent.js';
import RenaiEventDiagram from '../hacks/RenaiEventDiagram.js';
import LoginSSO from '../auth/LoginSSO.js';

import React, { useState, useEffect } from 'react';
import useAnalytics from '../support/Analytics.js';
import { Helmet } from "react-helmet";
import { Link as RouterLink, useLocation, useRouteMatch, useHistory} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Clear from '@material-ui/icons/Clear';
import FilterListIcon from '@material-ui/icons/FilterList';
import Badge from '@material-ui/core/Badge';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

const filterListStyles = makeStyles((theme) => ({
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    sectionMobile: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        '& > .MuiPaper-root': {
            padding: '1em',
            maxWidth: '75%',
            width: 'auto'
        }
    }
}));
const FilterList = (props) => {
    const { tags, UpdateTags, mobileOpen, toggleMobile, enabled } = props;
    const classes = filterListStyles();
    
    const toggleFilter = (tagId) => {
        return function (optionId) {
            UpdateTags(tagId, optionId);
        }
    };

    const renderPickers = (m) => {
        var out = [], count = 0;
        if (!tags || tags.length == 0)
            return <Typography variant="body1" gutterBottom>No filters available</Typography>;
        for (var i = 0; i < tags.length; i++) {
            if (!tags[i].hidden) {
                out.push(<TagPicker enabled={enabled} mobile={m}
                    open={count < 3 || tags[i].options.reduce((curr, o) => { return curr ? true : o.enabled; }, false) == true}
                        key={ 'mobile-filter-' + tags[i].id } 
                       UpdateTags={ toggleFilter(tags[i].id)} tag={tags[i]} />);
                count++;
            }
        }
        return out;
    };

    return (
        <div>
            <SwipeableDrawer id="filter-drawer" keepMounted className={classes.sectionMobile} anchor='left' open={mobileOpen} onClose={() => { toggleMobile(false) }} onOpen={() => { toggleMobile(true) }}>
                <Box display="flex" justifyContent="space-between">
                    <Typography variant="h2" gutterBottom>Filter</Typography>
                    <IconButton aria-label="close" aria-controls="filter-drawer" onClick={() => { toggleMobile(false) }} color="inherit"><Clear /></IconButton>
                </Box>
                {renderPickers(true)}
            </SwipeableDrawer>
            <div className={classes.sectionDesktop}>
                <Typography variant="h2" gutterBottom>Filter</Typography>
                {renderPickers(false)}
            </div>
        </div>
    );
};

const pageListStyles = makeStyles((theme) => ({
    main: {
        flexGrow: 1
    },
    list: {
        
    },
    sort: {     
        color: "var(--darkBlue)",
        textTransform: "uppercase",
        '& > .MuiInputBase-input': {
            fontWeight: 700,
            fontSize: ".9rem",
            padding: '5px 24px 5px 5px'
        },
        textDecoration: "none",
            marginLeft: "1em", 
        [theme.breakpoints.down('sm')]: {
            flex: '0 0 100%',
            marginLeft: 0,
            marginBottom: '10px'
        },

        fontFamily: "var(--secondaryText)",
        border: 'none',
        content: 'none',
        transition: 'none',
        transform: 'none',
        borderBottom: '2px solid var(--red)',   
        //marginTop: 0,
        '&::before': {
            content: 'none',
            border: 'none',
            transition: 'none',
            transform: 'none'
        },
        '&::after': {
            content: 'none',
            border: 'none',
            transition: 'none',
            transform: 'none'
        },
        '&::hover': {
            content: 'none',
            border: 'none',
            transition: 'none',
            transform: 'none'
        },
     
        
    },
    sortItem: {        
        fontFamily: "var(--secondaryText)",
        color: "var(--darkBlue)", 
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: ".9rem",
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    sectionMobile: {
        display: 'unset',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        '& > .MuiPaper-root': {
            padding: '1em',
            maxWidth: '75%',
            width: 'auto'
        }
    },
    filterWrapper: {
        flexBasis: '0%',
        flexShrink: '0',
        [theme.breakpoints.up('md')]: {
            flexBasis: (!!window.MSInputMethodContext && !!document.documentMode)?'auto':'25%',
        }
    }
}));

function GetPageSizeSetting(settings, areaurl) {
    switch (areaurl) {
        case "renaissance_showcase":
            return parseInt(settings.get("Renai Pages fetch size"))
            break;
        case "renaissance_events":
            return 1000;
            break;
        default:
            return parseInt(settings.get("Pages fetch size"));
            break;
    }
}

const PageList = (props) => {
    let location = useLocation();
    let history = useHistory();
    let match = useRouteMatch();
    let settings = useSettings();
    const analytics = useAnalytics();

    var query = new URLSearchParams(location.search);
    const classes = pageListStyles();
    const auth = useAuth();
    const { area } = props;
    const [canContribute, setCanContribute] = useState(false);
    const [canApprove, setCanApprove] = useState(false);
    const [canContributeCollection, setCanContributeCollection] = useState(false);
    const [canApproveCollection, setCanApproveCollection] = useState(false);
    const [tags, setTags] = useState(TagService.cachedList[area.url] || []);
    const [pages, setPages] = useState([]);
    const [filter, setFilter] = useState(props?.filter ?? query.get('filter') ?? '');//can set initial search on URL args or props
    const [sort, setSort] = useState(props?.sort ?? query.get('sort') ?? 'popularity');//can set initial search on URL args or props
    const [canLoadMore, setCanLoadMore] = useState(false);//for infinite loading
    const [initialised, setInitialised] = useState(false);//make sure tags are loaded before initial pages load to prevent double load
    const [pageSize, setPageSize] = useState(GetPageSizeSetting(settings, area.url) || 10);
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [queryLoaded, setQueryLoaded] = useState(query.get("loaded"));
    const [loading, setLoading] = useState(true);
    const [showSorter, setShowSorter] = useState(area.hide_sort || true);

    const [newAttendanceIds, setNewAttendanceIds] = useState([]);

    const [override, setOverride] = useState(null);

    useEffect(() => {
        if (area.url == "article" || area.url == "showcase" || area.url == "page" || area.url == "unlisted" || area.url == "renaissance_showcase" || area.url == "renaissance_events") {
            setCanContribute(auth.user.id && auth.user?.roles && auth.user.roles.indexOf(area.url + ".contributor") !== -1);
            setCanApprove(auth.user.id && auth.user?.roles && auth.user.roles.indexOf(area.url + ".approver") !== -1);
            if (area.url == "article") {
                setCanContributeCollection(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("collection.contributor") !== -1);
                setCanApproveCollection(auth.user.id && auth.user?.roles && auth.user.roles.indexOf("collection.approver") !== -1);
            }
        } else if (area.url != "search" && auth.user.id && auth.user?.roles && auth.user.roles.indexOf("admin") !== -1) {
            setCanContribute(true);
            setCanApprove(true);
        } else {
            setCanContribute(false);
            setCanApprove(false);
            setCanContributeCollection(false);
            setCanApproveCollection(false);
        }
    }, [area,auth]);

    useEffect(() => {
        query = new URLSearchParams(location.search);
        var f = query.get('filter') ?? filter ?? '';
        if(f != filter){}
            setFilter(f);
        var changedTags = applyEnabled(tags);
        if (changedTags) {
            findOverride(changedTags);
            setTags(changedTags);
        }
    },[location]);

    var applyEnabled = function (tgs) {
        var oldSelectedTags = [], response = [...tgs];

        var changed = false;
        var queryTags = query.getAll('options');
        if (queryTags.length > 0) {
            oldSelectedTags = queryTags.map((t) => parseInt(t));
        }
        for (var i = 0; i < response.length; i++) {
            for (var j = 0; j < response[i].options.length; j++) {
                var newE = (oldSelectedTags.indexOf(response[i].options[j].id) !== -1);
                if (newE != response[i].options[j].enabled) {
                    changed = true;
                }
                response[i].options[j].enabled = newE;
            }
        }
        if (changed)
            return response;
        else
            return null;
    };
    const [lastTagFetch, setLastTagFetch] = useState(0);
    var fetchTags = function () {
        var time = settings.get("Tags last updated");
        if (lastTagFetch !== time) {
            setLastTagFetch(time);
            setPageSize((area.url === "renaissance_showcase" ? parseInt(settings.get("Renai Pages fetch size")) : parseInt(settings.get("Pages fetch size"))) || 10);
            TagService.getList({ area: area.url }, time)
                .then((response) => {
                    var changed = applyEnabled(response);
                    setTags(changed ? changed : response);
                    setInitialised(true);
                    setLoading(true);
                    findOverride(changed ? changed : response);
                })
                .catch(function (e) {
                    setTags([]);
                });
        }
    };
    useEffect(fetchTags, [settings]);

    const findOverride = (tgs) => {
        if (!tgs) tgs = tags;
        //determine override tag if enabled
        var cat = null, tgs = [...tgs];
        for (var i = 0; i < tgs.length; i++) {
            if (tgs[i].isCategory) {
                for (var j = 0; j < tgs[i].options.length; j++) {
                    if (tgs[i].options[j].enabled) {
                        cat = tgs[i].options[j];
                        break;
                    }
                }
            }
        }
        setOverride(cat);
    };

    const fetchPages = (showMore = false) => {

        if (!initialised) return false;

        var tagRequest = [];
        for (var i = 0; i < tags.length; i++) {
            for (var j = 0; j < tags[i].options.length; j++) {
                if (tags[i].options[j].enabled) {
                    tagRequest.push(tags[i].options[j].id);
                }
            }
        }

        if (pageSize) {
            var newPages = (showMore ? [...pages] : []);
            var req = { filter: filter, page: Math.floor(newPages.length / pageSize), pageSize: pageSize, options: tagRequest, area: area.url, sort: sort };
            //initial query load
            if (queryLoaded && queryLoaded > pageSize) {
                req.page = 0;
                req.pageSize = queryLoaded;
                setQueryLoaded(0);
            }

            setLoading(true);
            PageService.getList(req)
                .then((response) => {
                    if ('data' in response && 'data' in response.data) {
                        var l = newPages.length;
                        for (var i = 0; i < response.data.data.length; i++) {
                            var found = false;
                            for (var j = 0; j < l; j++) {
                                if (newPages[j].id == response.data.data[i].id) {
                                    found = true;
                                    break;
                                }
                            }
                            if (!found) {
                                newPages.push(response.data.data[i]);
                            }
                        }

                        setPages(newPages);
                        console.log("fetched", newPages.length, "of", response.data.total, "pages");
                        setCanLoadMore(response.data.total != newPages.length);
                        analytics.tag('event', 'view_search_results', {
                            search_term: filter,
                            items: newPages.map((p) => { return { item_id: p.id, item_name: p.title }; })
                        });

                        const params = new URLSearchParams();
                        if (filter) params.append('filter', filter); else params.delete('filter');
                        if (sort) params.append('sort', sort); else params.delete('sort');
                        params.delete('options');
                        if (tagRequest.length > 0) {
                            for (var i = 0; i < tagRequest.length; i++)
                                params.append('options', tagRequest[i]);
                        }
                        params.append('loaded', newPages.length);
                        history.replace(match.path + "?" + params.toString());

                        setLoading(false);
                    }
                })
                .catch(function (e) {

                });
        }
    };
    useEffect(fetchPages, [filter, sort, tags, initialised]);

    const UpdateTags = (tagId, optionId, forceUnselect = false) => {
        var oldTags = [...tags];
        var needUpdate = false;
        //for each in the tag db
        for (var t = 0; t < oldTags.length; t++) {
            if (oldTags[t].id == tagId) {
                var enabled = false;
                for (var o = 0; o < oldTags[t].options.length; o++) {
                    if (oldTags[t].options[o].id == optionId) {
                        oldTags[t].options[o].enabled = !oldTags[t].options[o].enabled;
                        enabled = oldTags[t].options[o].enabled;
                        needUpdate = true;
                        break;
                    }
                }

                //turn off other group members if needed
                if ((oldTags[t].type == "single" || forceUnselect) && enabled) {
                    for (var o = 0; o < oldTags[t].options.length; o++) {
                        if (oldTags[t].options[o].id != optionId) {
                            oldTags[t].options[o].enabled = false;
                        }
                    }
                }
                break;
            }
        }


        if (needUpdate) {
            setTags(oldTags);
            findOverride(oldTags);
            var selectedOptions = [];
            for (var t = 0; t < oldTags.length; t++) {
                for (var o = 0; o < oldTags[t].options.length; o++) {
                    if (oldTags[t].options[o].enabled) {
                        selectedOptions.push(oldTags[t].options[o].id);
                    }
                }
            }
            //localStorage.setItem("lthub_selected_tags", JSON.stringify(selectedOptions));
        }
    };

    const applyFilter = (v) => {
        if ((sort != "" && v == "") || v != "") {
            setSort("score");
            analytics.tag('event', 'search', { search_term: v });
        }
        setFilter(v);
    };
    const applySort = (e) => {
        setSort(e.target.value);
    };
    const handleShowMore = () => {
        setCanLoadMore(false);
        fetchPages(true);
    };

    const generateTitle = () => {
        if (override == null) {
            return area.plural;
        } else {
            return override.name;
        }
    };

    const onSubmitAttendance = (page) => {
        const newAtt = [...newAttendanceIds];
        newAtt.push(page);
        setNewAttendanceIds(newAtt);
    };

    const generateIntro = () => {
        if (override == null) {
            switch (area.url) {
                case "renaissance_showcase":
                case "showcase":
                case "article":
                case "search":
                    return (<Page area={area} id={"setting-" + area.url + " Intro"} embed={true} />);
                case "renaissance_events":
                    return <RenaiEventDiagram area={area} tags={tags} newAttendanceTagIds={[]} onSelectDomain={(tagId, optionId) => UpdateTags(tagId, optionId, true)} />;
                case "template":
                    return (<p>Templates are a special page type which does not show up in search results,
                    they are intended to be used as a starting point for other page types.
                    For example, if you make a template page setting out the basic headings and structure
                    for an Article and then assign it as the article template in the Site Settings area,
                    any new Articles created will start with the content of the template.</p>);
                case "page":
                    return (<p>Loose pages are normal pages in the system but are not articles or showcase pages. Unlike Unlisted pages, they <b>can</b> be found using the sitewide search.</p>);
                case "unlisted":
                    return (<p>Unlisted pages are normal pages in the system but are not articles or showcase pages. Unlike Loose pages, they <b>cannot</b> be found using the sitewide search.</p>);
                case "collection":
                    return (<p>Collections are a curated, commentated list of other articles and resources in the hub.</p>);
                default: break;

            }
        } else {
            return (<p>{override.description}</p>);
        }
    };

    const [pickedTags, setPickedTags] = React.useState(0);
    const calcPickedTags = () => {
        var count = 0;
        if (!tags)
            return count;
        for (var i = 0; i < tags.length; i++) {
            if (tags[i].hidden == false) {
                for (var j = 0; j < tags[i].options.length; j++) {
                    if (tags[i].options[j].enabled)
                        count++;
                }
            }
        }
        setPickedTags(count);
    };
    useEffect(calcPickedTags, [tags]);

    const toggleMobile = (o) => {
        setMobileOpen(o);
    }

    const toggleShowSorter = (show) => {
        setShowSorter(show);
    };

    const RenderGrid = () => {
        switch(area.url){
            case "renaissance_showcase":
                return <HexPagePreviewGrid pages={pages} />;
            case "renaissance_events":
                return <RenaiEventPagePreviewGrid pages={pages} onSubmitAttendance={onSubmitAttendance} newAttendanceIds={newAttendanceIds} toggleShowSorter={toggleShowSorter} tags={tags} />;
            default:
                return <Grid container spacing={3}>
                    {pages.length > 0 ?
                        pages.map((page) => {
                            return (
                                <Grid key={page.id} item sm={area.url == "showcase" ? 6 : 12} xs={12}><PagePreview page={page} tags={tags} area={area} /></Grid>
                            );
                        })
                        :
                        (loading ? <CircularProgress /> : <Typography>No {generateTitle()} matching your criteria were found.</Typography>)
                    }
                </Grid>;
        }
    };

    if (area.features.indexOf("homepage_private") !== -1 && !auth.user.id)
        return auth.loading ? <CircularProgress /> : <SSORequest onSuccess={() => { }} message="Login is required to access this resource" />;

    return (
        <div>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h1" gutterBottom>
                    <Tooltip title="Display filters" className={classes.sectionMobile}>
                        <Badge badgeContent={pickedTags} color="primary" overlap="circle" anchorOrigin={{ vertical: 'top', horizontal: 'left' }} showZero>
                            <IconButton className={classes.sectionMobile} color="primary" aria-label="show filters" aria-controls="filter-drawer" aria-haspopup="true" onClick={() => { toggleMobile(true) }} color="inherit">
                                <FilterListIcon />
                            </IconButton>
                        </Badge>
                    </Tooltip>
                    {generateTitle()}
                </Typography>
                {(canContribute || canContributeCollection) ? <div>
                    {canContribute ?
                        <Tooltip title={"Add new " + area.name}>
                            <Button size="small" color="primary" variant="contained" component={RouterLink} to={"/" + area.url + "/0/edit"}><AddIcon /> New {area.name}</Button>
                        </Tooltip>
                        : null}
                    &nbsp;
                    {canContributeCollection ?
                        <Tooltip title={"Add new collection"}>
                            <Button size="small" color="primary" variant="contained" component={RouterLink} to={"/collection/0/edit"}><AddIcon /> New Collection</Button>
                        </Tooltip>
                        : null}
                </div> : null }
            </Box>
            {generateIntro()}
          
            <Box display="flex">
                <Helmet>
                    <title>{AppTitle(generateTitle())}</title>
                </Helmet>
                <Box flexGrow={0} flexShrink={1} flexBasis={'25%'} className={classes.filterWrapper}>
                    <FilterList tags={tags} UpdateTags={UpdateTags} toggleMobile={toggleMobile} mobileOpen={mobileOpen} enabled={!loading} />
                </Box>

                <Box flexGrow={1}>
                    <Box display="flex" alignItems="flex-start" flexWrap="wrap">
                        <SearchBar onSearch={applyFilter} tip={"Search " + generateTitle()} filter={filter} disabled={loading} />
           
                        {showSorter ? <Select aria-label="select result sort order" value={sort} onChange={applySort} className={classes.sort} disabled={loading}>
                            <MenuItem className={classes.sortItem} value="popularity">Popularity</MenuItem>
                            <MenuItem className={classes.sortItem} value="score">Relevance</MenuItem>
                            <MenuItem className={classes.sortItem} value="title">Alphabetical</MenuItem>
                            <MenuItem className={classes.sortItem} value="modified">Date Updated</MenuItem>
                            {(canApprove || canContribute) ? <MenuItem value="state">Workflow</MenuItem> : null}
                        </Select> : null}
                     
                    </Box>
                    <Typography variant="h2" gutterBottom className="screen-reader-only">Results</Typography>
                    {RenderGrid()}
                    <Box textAlign="center" paddingBottom="20px">{canLoadMore ? (<Button onClick={handleShowMore} variant="contained" color="primary">Show More <ExpandMoreIcon /></Button>) : null}</Box>
                </Box>
            </Box>
        </div>
    );
};

function SSORequest(props) {
    return <>
        {props.message ? <Typography variant="body1">{props.message}</Typography> : null}
        <LoginSSO {...props} />
    </>;
}

export default PageList;
